import React from 'react'

const NewsFeed = () => {
  return (
    <div>NewsFeed</div>
  )
}

export default NewsFeed